/**
 * Broadcast timestamp: "07 Aug 2026 · 11:23:41 BST".
 *
 * Rendered in the viewer's own locale and time zone. `timeZoneName: 'short'`
 * gives the abbreviation traders actually say out loud (BST, EST, JST).
 */
export function formatCallTimestamp(ms: number, locale?: string): string {
  const date = new Date(ms);
  const day = new Intl.DateTimeFormat(locale ?? 'en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
  const time = new Intl.DateTimeFormat(locale ?? 'en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  }).format(date);
  return `${day} · ${time}`;
}

/** Share-card date: "07 AUG 2026". */
export function formatShareDate(ms: number, locale?: string): string {
  return new Intl.DateTimeFormat(locale ?? 'en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
    .format(new Date(ms))
    .toUpperCase()
    .replace(/,/g, '');
}

/** Compact relative age for the record table: "4m", "3h", "12d". */
export function formatRelativeAge(ms: number, now = Date.now()): string {
  const seconds = Math.max(0, Math.round((now - ms) / 1000));
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.round(hours / 24)}d`;
}

